import { Component, Input, ContentChildren, QueryList, AfterContentInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CollapsePanelComponent } from './collapse-panel/collapse-panel.component';
 
@Component({
  selector: 'app-collapse',
  template: '<ng-content></ng-content>'
})
export class CollapseComponent implements AfterContentInit, OnDestroy {
  @Input() accordion: boolean;
  @ContentChildren(CollapsePanelComponent) collapsePanels: QueryList<CollapsePanelComponent>;
  private destroyed$ = new Subject();
  
  ngAfterContentInit() {
    this.collapsePanels.forEach((panel, index) => {
      if (this.accordion && index === 0) {
        setTimeout(() => panel.opened = true);
      }

      panel.toggle
        .pipe(takeUntil(this.destroyed$))
        .subscribe(() => this.togglePanels(panel));
      });
  }

  togglePanels(panel: CollapsePanelComponent) {
    if (!this.accordion) {
      panel.opened = !panel.opened;
      return;
    }
    this.collapsePanels.forEach(panel => panel.opened = false);
    panel.opened = true;
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }
}